import { Resource } from '../resource';

export class NovaPoshta extends Resource {
    name: string | null | undefined;
}